import epsClient from 'enrollment-platform/api/eps.client'
import type {
  LocationLevelHistoryQueryDto,
  PaginatedLocationLevelHistoryResponseDto,
} from './dto/location-level-history.dto'
import type {
  BulkDeleteLocationOverrideRulesRequestDto,
  BulkUpdateLocationStatusByIdsRequestDto,
  CheckDuplicateLocationOverrideRuleQueryDto,
  CheckDuplicateLocationOverrideRuleResponseDto,
  CreatePlanLocationOverrideRuleRequestDto,
  DeleteLocationOverrideRulesByFilterRequestDto,
  DeleteLocationOverrideRulesByFilterResponseDto,
  ListPlanLocationOverrideRulesQueryDto,
  ListPlanLocationOverrideRulesResponseDto,
  PlanLocationOverrideRuleResponseDto,
  UpdateLocationStatusByFilterBodyDto,
  UpdateLocationStatusByFilterQueryDto,
  UpdateLocationStatusByFilterResponseDto,
  UpdatePlanLocationOverrideRuleRequestDto,
  UpdatePlanLocationOverrideRuleStatusRequestDto,
} from './dto/plan-location-override-rules.dto'

export const LOCATION_OVERRIDE_RULE_BASE =
  '/api/v1/plan-location-override-rules'

export const listLocationOverrideRules = async (
  params: ListPlanLocationOverrideRulesQueryDto
): Promise<ListPlanLocationOverrideRulesResponseDto> => {
  const { data } =
    await epsClient.get<ListPlanLocationOverrideRulesResponseDto>(
      LOCATION_OVERRIDE_RULE_BASE,
      { params }
    )
  return data
}

export const getLocationOverrideRule = async (
  id: string
): Promise<PlanLocationOverrideRuleResponseDto> => {
  const { data } = await epsClient.get<PlanLocationOverrideRuleResponseDto>(
    `${LOCATION_OVERRIDE_RULE_BASE}/${id}`
  )
  return data
}

export const createLocationOverrideRule = async (
  body: CreatePlanLocationOverrideRuleRequestDto
): Promise<PlanLocationOverrideRuleResponseDto> => {
  const { data } = await epsClient.post<PlanLocationOverrideRuleResponseDto>(
    LOCATION_OVERRIDE_RULE_BASE,
    body
  )
  return data
}

export const updateLocationOverrideRule = async (
  id: string,
  body: UpdatePlanLocationOverrideRuleRequestDto
): Promise<PlanLocationOverrideRuleResponseDto> => {
  const { data } = await epsClient.patch<PlanLocationOverrideRuleResponseDto>(
    `${LOCATION_OVERRIDE_RULE_BASE}/${id}`,
    body
  )
  return data
}

export const checkDuplicateLocationOverrideRule = async (
  query: CheckDuplicateLocationOverrideRuleQueryDto
): Promise<CheckDuplicateLocationOverrideRuleResponseDto> => {
  const { data } =
    await epsClient.get<CheckDuplicateLocationOverrideRuleResponseDto>(
      `${LOCATION_OVERRIDE_RULE_BASE}/check-duplicate`,
      { params: query }
    )
  return data
}

export const updateLocationOverrideRuleStatus = async (
  id: string,
  body: UpdatePlanLocationOverrideRuleStatusRequestDto
): Promise<PlanLocationOverrideRuleResponseDto> => {
  const { data } = await epsClient.patch<PlanLocationOverrideRuleResponseDto>(
    `${LOCATION_OVERRIDE_RULE_BASE}/${id}/status`,
    body
  )
  return data
}

export const deleteLocationOverrideRule = async (id: string): Promise<void> => {
  await epsClient.delete(`${LOCATION_OVERRIDE_RULE_BASE}/${id}`)
}

export const bulkDeleteLocationOverrideRules = async (
  body: BulkDeleteLocationOverrideRulesRequestDto
): Promise<void> => {
  await epsClient.delete(`${LOCATION_OVERRIDE_RULE_BASE}/bulk`, { data: body })
}

export const deleteLocationOverrideRulesByFilter = async (
  params: DeleteLocationOverrideRulesByFilterRequestDto
): Promise<DeleteLocationOverrideRulesByFilterResponseDto> => {
  const { data } = await epsClient.delete(LOCATION_OVERRIDE_RULE_BASE, {
    params,
  })
  return data as DeleteLocationOverrideRulesByFilterResponseDto
}

export const bulkUpdateLocationStatusByIds = async (
  body: BulkUpdateLocationStatusByIdsRequestDto
): Promise<void> => {
  await epsClient.patch(`${LOCATION_OVERRIDE_RULE_BASE}/bulk/status`, body)
}

export const updateLocationStatusByFilter = async (
  query: UpdateLocationStatusByFilterQueryDto,
  body: UpdateLocationStatusByFilterBodyDto
): Promise<UpdateLocationStatusByFilterResponseDto> => {
  const { data } =
    await epsClient.patch<UpdateLocationStatusByFilterResponseDto>(
      `${LOCATION_OVERRIDE_RULE_BASE}/status`,
      body,
      { params: query }
    )
  return data
}

export const listLocationLevelHistory = async (
  params: LocationLevelHistoryQueryDto
): Promise<PaginatedLocationLevelHistoryResponseDto> => {
  const { data } =
    await epsClient.get<PaginatedLocationLevelHistoryResponseDto>(
      `${LOCATION_OVERRIDE_RULE_BASE}/history`,
      { params }
    )
  return data
}
